module.exports = __webpack_public_path__ + "img/text.ee103046.svg";